import { useTranslate } from "@tolgee/react";
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from "#/components/ui/alert-dialog";
import { Button } from "#/components/ui/button";
import { isOptimisticOrder } from "#/hooks/optimistic-updates";
import type { OpenOrderRowItem } from "./types/positions.types.ts";

type OpenOrderCancelCellProps = {
	order: OpenOrderRowItem;
	onCancel: (order: OpenOrderRowItem) => void;
};

export function OpenOrderCancelCell({
	order,
	onCancel,
}: OpenOrderCancelCellProps) {
	const { t } = useTranslate();

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button
					type="button"
					variant="ghost"
					size="xs"
					// In-flight optimistic order (negative oid) — no real oid to cancel yet.
					disabled={isOptimisticOrder(order)}
					className="justify-self-start px-0 text-trade-red hover:bg-transparent hover:text-trade-red/80"
				>
					{t("general.cancel")}
				</Button>
			</AlertDialogTrigger>
			<AlertDialogContent size="sm">
				<AlertDialogHeader>
					<AlertDialogTitle>
						{t("orders.cancel-confirm-title")}
					</AlertDialogTitle>
					<AlertDialogDescription>
						{t("orders.cancel-confirm-description", {
							side: order.side === "B" ? "buy" : "sell",
							type: "PERP",
							size: order.sz,
							coin: order.coin,
							price: order.limitPx,
						})}
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel size="sm">{t("actions.keep")}</AlertDialogCancel>
					<AlertDialogAction
						size="sm"
						variant="destructive"
						onClick={() => void onCancel(order)}
					>
						{t("orders.cancel-confirm")}
					</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	);
}
